import React from "react";
import moment from "moment";
// MDB Shim Imports
import Col from "../../Component/MDBShim/Col";
import MDBIcon from "../../Component/MDBShim/MDBIcon";
import MDBNav from "../../Component/MDBShim/MDBNav";
import MDBNavItem from "../../Component/MDBShim/MDBNavItem";
import MDBNavLink from "../../Component/MDBShim/MDBNavLink";
import Row from "../../Component/MDBShim/Row";
import TabContent from "../../Component/MDBShim/TabContent";
import ToastContainer from "../../Component/MDBShim/ToastContainer";
import Button from "../../Component/MDBShim/Button";
import MDBModal from "../../Component/MDBShim/MDBModal";
import MDBModalHeader from "../../Component/MDBShim/MDBModalHeader";
import MDBModalBody from "../../Component/MDBShim/MDBModalBody";
import MDBCol from "../../Component/MDBShim/MDBCol";
import MDBModalFooter from "../../Component/MDBShim/MDBModalFooter";
import toast from "../../Component/MDBShim/toast";
import Container from "../../Component/MDBShim/Container";
import Spinner from "../../Component/MDBShim/Spinner";
import MDBCardHeader from "../../Component/MDBShim/MDBCardHeader";
import MDBRow from "../../Component/MDBShim/MDBRow";
import MDBInput from "../../Component/MDBShim/MDBInput";

import { enqueueSnackbar as NotistackEnqueueSnackbar } from "notistack";
import MUIBox from "@mui/material/Box";
import MUIAutocomplete from "@mui/material/Autocomplete";
import MUITextField from "@mui/material/TextField";
import MUIInventoryIcon from "@mui/icons-material/Inventory";
import ActivitiesReport from "./activityReport";
import SalesReport from "./salesReport";
import ApprovalReport from "./approvalReport";
import ServicesReport from "./servicesReport";
import DeliveryReport from "./deliveryReport";
import ExpensesReport from "./expensesReport";
import ComplaintReport from "./complaintReport";
import ServiceOrderReasonReport from "./serviceOrderReasonReport";
import AccountReport from "./accountReport";
import PropTypes from "prop-types";
import QuickFilter from "../Filters/quickFilter";
import Select from "react-select";
import ReactTooltip from "react-tooltip";
import api from "../Security/api";
import ReportsService from "../Security/ReportsService/reportsService";
import userService from "../Security/UserService/userService";
import { DatePicker as MUIDatePicker } from '@mui/x-date-pickers/DatePicker';
import LayerLegacy from "../../LayerLegacy";
import Exporter from "../../Utility/Exporter";
import Setting from "../../Utility/Setting";
import MainContext from "../../Context/MainContext/MainContext";

export default class reports extends LayerLegacy {
    constructor(props) {
        super(props);

        const roles = [
            {label: '---NONE---', value: null},
            {label: 'ADMIN', value: 'ADMIN'},
            {label: 'AREA_MANAGER', value: 'AREA_MANAGER'},
            {label: 'REGIONAL_OPERATIONS_MANAGER', value: 'REGIONAL_OPERATIONS_MANAGER'},
            {label: 'BILLING', value: 'BILLING'},
            {label: 'COLLECTIONS', value: 'COLLECTIONS'},
            {label: 'CUSTOMER_EXPERIENCE', value: 'CUSTOMER_EXPERIENCE'},
            {label: 'EXECUTIVE_MANAGEMENT', value: 'EXECUTIVE_MANAGEMENT'},
            {label: 'FINANCE', value: 'FINANCE'},
            {label: 'FOLLOWUP', value: 'FOLLOWUP'},
            {label: 'MARKETING', value: 'MARKETING'},
            {label: 'MARKETING_MANAGER', value: 'MARKETING_MANAGER'},
            {label: 'OFFICE_SUPPORT', value: 'OFFICE_SUPPORT'},
            {label: 'CARE_COORDINATOR', value: 'CARE_COORDINATOR'},
            {label: 'OFFICE_MANAGER', value: 'OFFICE_MANAGER'},
            {label: 'PURCHASING', value: 'PURCHASING'},
            {label: 'SALES', value: 'SALES'},
            { label: 'BUSINESS_SUPPORT', value: 'BUSINESS_SUPPORT' },
            {label: 'SALES_MANAGER', value: 'SALES_MANAGER'},
            {label: 'SERVICE_TEAM', value: 'SERVICE_TEAM'},
            {label: 'TECHNICIAN', value: 'TECHNICIAN'},
            {label: 'THIRD_PARTY_USER', value: 'THIRD_PARTY_USER'},
            {label: 'VERIFICATION', value: 'VERIFICATION'},
            {label: 'WAREHOUSE_TECHNICIAN', value: 'WAREHOUSE_TECHNICIAN'},
        ];

        const months = [
            {label: 'January', value: 1},
            {label: 'February', value: 2},
            {label: 'March', value: 3},
            {label: 'April', value: 4},
            {label: 'May', value: 5},
            {label: 'June', value: 6},
            {label: 'July', value: 7},
            {label: 'August', value: 8},
            {label: 'September', value: 9},
            {label: 'October', value: 10},
            {label: 'November', value: 11},
            {label: 'December', value: 12},
        ];

        let years = [];
        let thisYear = new Date().getFullYear();

        for (var i = 2019; i <= thisYear; i++) {
            years.push({label: i, value: i});
        }

        this.state = {
            activeItem: "1",
            isSetupLoaded: false,
            isOpen: true,
            users: [],
            currUser: {},
            allLocs: [],
            allSalesReps: [],
            filteredSalesReps: [],
            locationsSelect: [{
                label: 'Loading...',
                value: 'loading'
            }],
            salesRepsSelect: [{
                label: 'Loading...',
                value: 'loading'
            }],
            locationsSelected: [],
            salesRepsSelected: [],
            showDatePicker: false,
            quickFilter: [],
            quickFilterSelected: null,
            salesRadio: 1,
            allProducts: true,
            pointsOnlyProducts: false,
            startDate: null,
            endDate: null,
            techsSelect: [{
                label: 'Loading...',
                value: 'loading'
            }],
            techsSelected: [],
            allTechs: [],
            filteredTechs: [],
            generateClicked: 0,
            monthList: months,
            yearList: years,
            roleList: roles,
            selectedMonth: null,
            selectedYear: null,
            selectedRole: null,
            processing: false,
            internalLocations: [],
            allInternalLocations: [],

            saveFiltersToggle: false,
            userReportFilters: [],
            myFilterName: 'myFilter',
            listFiltersToggle: false,

            selectedLocationNames: "Choose Locations",
            userAutoSelect: true,
        };
    }

    static contextType = MainContext; // For legacy class components

    componentDidMount() {
        this.getLocationOptions();
        this.getSalesRepOptions();
        this.getTechOptions();
        this.getFilterOptions();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {techs, salesReps, allLocations} = this.context;
        let st = this.state;
        if (st.allInternalLocations.length !== allLocations.length) {
            this.getLocationOptions();
        }
        if (st.allSalesReps.length !== salesReps.length) {
            this.getSalesRepOptions();
        }
        if (st.allTechs.length !== techs.length) {
            this.getTechOptions();
        }
    }

    handleQuickFilter = (e) => {
        let a = QuickFilter.getDates(e.value);

        let startD = null,
            endD = null;

        if (a && a.length > 0) {
            startD = a[0];
            endD = a[1];
        }

        this.setState({
            quickFilter: a,
            startDate: moment(startD),
            endDate: moment(endD),
            quickFilterSelected: e
        });
    };

    getFilterOptions() {
        const {currentUser} = this.context;
        let res = [];

        if (currentUser.userReportFilters && currentUser.userReportFilters.length > 0) {
            // push into res here
            currentUser.userReportFilters.forEach((val, idx) => {
                res.push({
                    label: val.name,
                    value: val
                });
            });
        }
        this.setState({
            userReportFilters: res
        });
    }

    getLocationOptions() {
        const {allLocations} = this.context;

        let a = [],
            oldIds = this.state.internalLocations;

        //Must add the checked and disabled for it to remain 'uncontrolled'...BC
        allLocations.map(loc => {
            let checked = false;

            //If the user filter had old ids in it, set them to default be selected...BC
            if (oldIds.indexOf(loc.id) > -1) {
                checked = true;
            }

            return a.push(
                {
                    checked: checked,
                    disabled: false,
                    text: loc.name,
                    value: loc.id
                }
            );
        });

        this.setState({
            allInternalLocations: a
        });
    }

    getSalesRepOptions(selectedLocationIds) {
        const {
            salesReps,
            userprofileLocationsIndexed
        } = this.context;

        let options = [];
        let selectedUserIds = [];
        let previouslySelectedUserIds = this.state.users || [];

        salesReps.forEach((salesRep) => {
            if (salesRep.active === false || salesRep.deleted === true) {
                return;
            }

            const userLocationIds =
                Object.values(userprofileLocationsIndexed)
                    .filter((userprofileLocation) => {
                        return userprofileLocation.userprofileId === salesRep.id;
                    })
                    .map((userprofileLocation) => {
                        return userprofileLocation.locationsId;
                    });

            const matchesSelectedLocations =
                !selectedLocationIds ||
                selectedLocationIds.length === 0 ||
                userLocationIds.some((locationId) =>
                    selectedLocationIds.includes(locationId)
                );

            if (!matchesSelectedLocations) {
                return;
            }

            let isChecked = previouslySelectedUserIds.includes(salesRep.id);

            if (isChecked) {
                selectedUserIds.push(salesRep.id);
            }

            options.push({
                disabled: false,
                checked: isChecked,
                text: `${salesRep.firstname} ${salesRep.lastname}`,
                value: salesRep.id,
            });
        });

        this.setState({
            filteredSalesReps: options,
            allSalesReps: salesReps,
            salesRepsSelected: selectedUserIds,
            updatedCheckedReps: true,
        });
    }

    getTechOptions(selectedLocationIds) {
        const {
            techs,
            userprofileLocationsIndexed
        } = this.context;

        let options = [];
        let selectedTechIds = [];

        techs.forEach((techUser) => {
            if (techUser.active === false || techUser.deleted === true) {
                return;
            }

            const userLocationIds =
                Object.values(userprofileLocationsIndexed)
                    .filter((userprofileLocation) => {
                        return userprofileLocation.userprofileId === techUser.id;
                    })
                    .map((userprofileLocation) => {
                        return userprofileLocation.locationsId;
                    });

            const matchesSelectedLocations =
                !selectedLocationIds ||
                selectedLocationIds.length === 0 ||
                userLocationIds.some((locationId) =>
                    selectedLocationIds.includes(locationId)
                );

            if (!matchesSelectedLocations) {
                return;
            }

            const isChecked =
                selectedLocationIds &&
                selectedLocationIds.length > 0;

            if (isChecked) {
                selectedTechIds.push(techUser.id);
            }

            options.push({
                disabled: false,
                checked: isChecked,
                text: `${techUser.firstname} ${techUser.lastname}`,
                value: techUser.id,
            });
        });

        this.setState({
            filteredTechs: options,
            allTechs: techs,
            techsSelected: selectedTechIds,
            updatedCheckedTechs: true,
        });
    }

    renderLocationSelect() {
        let st = this.state;

        if (st.activeItem !== '8') {
            return (
                <MUIAutocomplete
                    multiple
                    limitTags={2}
                    disableCloseOnSelect
                    options={this.state.allInternalLocations}
                    value={this.state.allInternalLocations.filter((o) =>
                        (this.state.locationsSelected || []).includes(o.value)
                    )}
                    getOptionLabel={(opt) => opt.text}
                    isOptionEqualToValue={(a, b) => a.value === b.value}
                    onChange={(_, newValue) => {
                        this.getLocationValue(newValue.map((o) => o.value));
                    }}
                    style={{ maxHeight: '100px', backgroundColor: 'white', margin: 0 }}
                    renderInput={(params) => (
                        <MUITextField
                            {...params}
                            size="small"
                            fullWidth
                            variant="outlined"
                            color="info"
                            placeholder="Choose Locations"
                        />
                    )}
                />
            );
        }
    }

    getLocationValue(e) {
        if (e.length === 0) {
            this.setState({
                selectedLocationNames: "Choose Locations"
            });
        }

        this.setState({
            locationsSelected: e,
        });
        this.getTechOptions(e);
        this.getSalesRepOptions(e);
    }

    renderRepTechSelect() {
        let st = this.state;

        if (st.activeItem === '6') {
            return;
        }

        if (st.activeItem === '7') {
            return (
                <MUIAutocomplete
                    multiple
                    limitTags={2}
                    disableCloseOnSelect
                    className="searchField"
                    options={this.state.filteredTechs}
                    value={this.state.filteredTechs.filter((o) =>
                        (this.state.techsSelected || []).includes(o.value)
                    )}
                    getOptionLabel={(opt) => opt.text}
                    isOptionEqualToValue={(a, b) => a.value === b.value}
                    onChange={(_, newValue) => {
                        this.handleTechChange(newValue.map((o) => o.value));
                    }}
                    style={{ maxHeight: '100px', backgroundColor: 'white', margin: 0 }}
                    renderInput={(params) => (
                        <MUITextField
                            {...params}
                            size="small"
                            fullWidth
                            variant="outlined"
                            placeholder="Choose Techs"
                        />
                    )}
                />
            );
        }

        if (st.activeItem !== '8') {
            return (
                // <UserDropdown
                //     className={(["6", "7", "8"].includes(this.state.activeItem) ? "searchfield hidden" : "searchfield")}
                //     selected={this.getSalesRepsValue.bind(this)}
                //     autoSelect={true}
                //     selectedIds={this.state.salesRepsSelected || []}
                //     roleFilters={["ADMIN", "SALES", "SALES_MANAGER"]}
                //     locationFilters={this.state.locationsSelected}
                //     canClear={this.state.canClear}
                //     resetFlag={() =>
                //         this.setState({canClear: false})
                //     }
                // />
                <MUIAutocomplete
                    multiple
                    limitTags={2}
                    disableCloseOnSelect
                    className="searchField"
                    options={this.state.filteredSalesReps}
                    value={this.state.filteredSalesReps.filter((o) =>
                        (this.state.salesRepsSelected || []).some((id) => id == o.value)
                    )}
                    getOptionLabel={(opt) => opt.text}
                    isOptionEqualToValue={(a, b) => a.value === b.value}
                    onChange={(_, newValue) => {
                        this.getSalesRepsValue(newValue.map((o) => o.value));
                    }}
                    style={{ maxHeight: '100px', backgroundColor: 'white', margin: 0 }}
                    renderInput={(params) => (
                        <MUITextField
                            {...params}
                            size="small"
                            fullWidth
                            variant="outlined"
                            placeholder="Choose Sales Reps"
                        />
                    )}
                />
            );
        }
    }

    getSalesRepsValue(e) {
        this.setState({
            salesRepsSelected: e,
        });
    }

    handleTechChange(e) {
        this.setState({
            techsSelected: e
        });
    };

    renderDateRow() {
        let st = this.state;

        return (
            <MDBRow gap={1}>
                <MDBCol size={'5.9'} >
                    <Select
                        placeholder='Quick Filter'
                        options={QuickFilter.getOptions()}
                        onChange={this.handleQuickFilter.bind(this)}
                        value={st.quickFilterSelected}
                    />
              
                </MDBCol>
                <MDBCol size={'2.9'} >
                    <MUIDatePicker
                        label="Start Date"
                        value={this.state.startDate ? this.state.startDate : null}
                        slotProps={{
                            textField: {
                                fullWidth: true,
                                size: "small",
                                variant: 'outlined',
                                InputLabelProps: {
                                    shrink: true
                                },
                                InputProps: {
                                    sx: {
                                        backgroundColor: "#fff",
                                        height: '40px', // Match the height of the Quick Filter Select
                                    },
                                },
                            },
                        }}
                        onChange={(value) => { this.setState({ startDate: value }); }}
                        views={['year', 'month', 'day']}
                    />
                </MDBCol>
                <MDBCol size={'2.9'}>
                    <MUIDatePicker
                        label="End Date"
                        value={this.state.endDate ? this.state.endDate : null}
                        slotProps={{
                            textField: {
                                fullWidth: true,
                                size: "small",
                                variant: 'outlined',
                                InputLabelProps: {
                                    shrink: true
                                },
                                InputProps: {
                                    sx: {
                                        backgroundColor: "#fff",
                                        height: '40px', // Match the height of the Quick Filter Select
                                    },
                                },
                            },
                        }}
                        onChange={(value) => { this.setState({ endDate: value }); }}
                        views={['year', 'month', 'day']}
                    />
                </MDBCol>
            </MDBRow>
        );
    }

    //This will convert all the data in the grid to a csv file
    clientCSV(stateData, filename) {
        let result,
            ctr,
            keys,
            columnDelimiter = ',',
            lineDelimiter = '\n',
            data;

        data = stateData.rows || null;
        if (data == null || !data.length) {
            return null;
        }

        keys = Object.keys(stateData.rows[0]);

        result = '';
        result += keys.join(columnDelimiter);
        result += lineDelimiter;

        data.forEach(function (item) {
            ctr = 0;
            keys.forEach(function (key) {
                if (ctr > 0) result += columnDelimiter;

                if (item[key] && item[key].toString().indexOf(",") >= 0)
                    result += '"' + item[key] + '"';
                else
                    result += item[key];
                ctr++;
            });
            result += lineDelimiter;
        });

        this.downloadBlob(result, filename);
    }

    //get Dashboard Information
    getDashboardInformation() {
        let t = this;

        function getVerificationDashboardRankings() {
            return new Promise((res, reject) => {
                api.get('/dashboardMonthlyVerificationRank').then(data => {
                    t.setState({verificationRankingsData: data});
                    res();
                }).catch(err => {
                    reject(err);
                });
            });
        }

        function getBillingDashboardRankings() {
            return new Promise((res, reject) => {
                api.get('/dashboardMonthlyBillingRank').then(data => {
                    t.setState({billingRankingsData: data});
                    res();
                }).catch(err => {
                    reject(err);
                });
            });
        }

        // calls proc spDashboardDailyBilling
        function getDailyBilling() {
            return new Promise((res, reject) => {
                api.get('/dashboardDailyBilling', {reason: 'Billed'}).then(data => {
                    t.setState({dailyBillingData: data});
                    res();
                }).catch(err => {
                    reject(err);
                });
            });
        }

        // calls proc spDashboardDailyBilling
        function getDailySalesPaperworkIssues() {
            return new Promise((res, reject) => {
                api.get('/dashboardDailyBilling', {reason: 'Sales PPW Issue'}).then(data => {
                    t.setState({salesPPWIssues: data});
                    res();
                }).catch(err => {
                    reject(err);
                });
            });
        }

        // calls proc spDashboardDailyBilling
        function getDailyDeliveryPaperworkIssues() {
            return new Promise((res, reject) => {
                api.get('/dashboardDailyBilling', {reason: 'Delivery PPW Issue'}).then(data => {
                    t.setState({deliveryPPWIssues: data});
                    res();
                }).catch(err => {
                    reject(err);
                });
            });
        }

        // calls proc spDashboardDailyBilling
        function getDailyPreAuth() {
            return new Promise((res, reject) => {
                api.get('/dashboardDailyBilling', {reason: 'Pre-Auth Issue'}).then(data => {
                    t.setState({preAuthIssues: data});
                    res();
                }).catch(err => {
                    reject(err);
                });
            });
        }

        function getMonthlyInsuranceMatrix() {
            return new Promise((res, reject) => {
                api.get('/dashboardMonthlyInsuranceMetrics').then(data => {
                    t.setState({insuranceMetrics: data});
                    res();
                }).catch(err => {
                    reject(err);
                });
            });
        }

        Promise.all([
            getVerificationDashboardRankings(),
            getBillingDashboardRankings(),
            getDailyBilling(),
            getDailySalesPaperworkIssues(),
            getDailyDeliveryPaperworkIssues(),
            getDailyPreAuth(),
            getMonthlyInsuranceMatrix()

        ]).then(() => {
            this.createClientCSV("", "dashboardData.csv");
        }).catch(e => {
            console.log(e);
            toast.error("There was an error getting the dashboard data.");
            NotistackEnqueueSnackbar('There was an error getting the dashboard data.', { variant: "error" });
        });
    }

    getProductionReport = () => {
        let month = this.state.selectedMonth,
            year = this.state.selectedYear,
            role = this.state.selectedRole || '';
        this.setState({processing: true});
        let filters = {
            month,
            year,
            role,
        };

        ReportsService.getProductionReport(filters).then(res => {
            this.toggleProductionModal();
            this.createProductionCsv(res, 'productionReport.csv');

        }).catch(err => {
            console.log(err);

            this.setState({processing: false});
            toast.error('An error occurred when getting the production report.');
            NotistackEnqueueSnackbar('An error occurred when getting the production report.', { variant: "error" });
        });
        ReportsService.getProductionMonthlyNotationsReport(filters).then(res2 => {
            this.createProductionCsv(res2, 'productionReportNotedOrders.csv');
        }).catch(err => {
            console.log(err);

            this.setState({processing: false});
            toast.error('An error occurred when getting the production notations report.');
            NotistackEnqueueSnackbar('An error occurred when getting the production notations report.', { variant: "error" });
        });
    };

    createProductionCsv(reportData, filename) {
        const csvRows = [];
        let options = {
            year: "2-digit",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            timeZoneName: "short"
        };

        if (filename === 'productionReport.csv') {
            csvRows.push(['Monthly Production Report']);
            csvRows.push(['Updated By', 'Role', 'Updated On', 'Status From', 'Reason From', 'Status', 'Reason', 'Orders Worked', 'Order Type']);

            reportData.forEach(col => {
                csvRows.push([
                    col.updatedBy,
                    col.role,
                    col.updatedOn,
                    col.statusFrom,
                    col.reasonFrom,
                    col.status,
                    col.reason,
                    col.ordersWorked,
                    col.orderType,
                ]);
            });
        }
        else {
            csvRows.push(['Monthly Production Report Noted Orders']);
            csvRows.push(['Username', 'Role', 'Updated On', 'Order Id', 'Text', 'Activity Id', 'Order Type']);

            reportData.forEach(col => {
                let dateString = new Date(col.dateUpdated).toLocaleString("en-US", options);

                let filterDateString = dateString.replace(/,/g, ' -');
                csvRows.push([
                    col.username,
                    col.role,
                    filterDateString,
                    col.orderId,
                    col.text,
                    col.activityId,
                    col.orderType,
                ]);
            });
        }

        Exporter.exportCSV(csvRows, filename);

        this.setState({processing: false});
    }

    //This will convert all the data in the grid to a csv file
    createClientCSV(stateData, filename) {
        let result = '',
            columnDelimiter = ',',
            lineDelimiter = '\n',
            st = this.state;

        //#region monthly verification orders
        result += 'Monthly Orders Moved From Verification';
        result += lineDelimiter;

        st.verificationRankingsData.forEach(col => {
            result += (col.updatedBy);
            result += (columnDelimiter);

            result += (col.ordersWorked);
            result += (lineDelimiter);
        });
        //#endregion

        result += lineDelimiter;
        result += lineDelimiter;

        //#region monthly billing orders
        result += 'Monthly Orders Moved From Billing';
        result += lineDelimiter;

        st.billingRankingsData.forEach(col => {
            result += (col.updatedBy);
            result += (columnDelimiter);

            result += (col.ordersBilled);
            result += (lineDelimiter);
        });
        //#endregion

        result += lineDelimiter;
        result += lineDelimiter;

        //#region Daily Billing orders
        result += 'Daily Orders Moved Into Billed';
        result += lineDelimiter;

        st.dailyBillingData.forEach(col => {
            result += (col.updatedBy);
            result += (columnDelimiter);

            result += (col.ordersBilled);
            result += (lineDelimiter);
        });
        //#endregion

        result += lineDelimiter;
        result += lineDelimiter;

        //#region Daily Sales PPW orders
        result += 'Daily Orders Moved Into Sales PPW Issue';
        result += lineDelimiter;

        st.salesPPWIssues.forEach(col => {
            result += (col.updatedBy);
            result += (columnDelimiter);

            result += (col.ordersBilled);
            result += (lineDelimiter);
        });
        //#endregion

        result += lineDelimiter;
        result += lineDelimiter;

        //#region Daily Delivery PPW orders
        result += 'Daily Orders Moved Into Delivery PPW Issue';
        result += lineDelimiter;

        st.deliveryPPWIssues.forEach(col => {
            result += (col.updatedBy);
            result += (columnDelimiter);

            result += (col.ordersBilled);
            result += (lineDelimiter);
        });
        //#endregion

        result += lineDelimiter;
        result += lineDelimiter;

        //#region Daily Pre Auth orders
        result += 'Daily Orders Moved Into Pre Auth Issue';
        result += lineDelimiter;

        st.preAuthIssues.forEach(col => {
            result += (col.updatedBy);
            result += (columnDelimiter);

            result += (col.ordersBilled);
            result += (lineDelimiter);
        });
        //#endregion

        result += lineDelimiter;
        result += lineDelimiter;

        //#region Insurance Metrics
        result += 'Insurance Metrics';
        result += lineDelimiter;

        st.insuranceMetrics.forEach(col => {
            result += (col.ndxKey);
            result += (columnDelimiter);

            result += (col.ndxValue);
            result += (lineDelimiter);
        });
        //#endregion

        this.downloadBlob(result, filename);
    }

    //this actually prompts the download
    downloadBlob(csvData, filename) {

        let blob = new Blob([csvData], {
            type: "application/csv;charset=utf-8;"
        });

        if (window.navigator.msSaveBlob) {
            // FOR IE BROWSER
            navigator.msSaveBlob(blob, filename);
        } else {
            // FOR OTHER BROWSERS
            let link = document.createElement("a"),
                csvUrl = URL.createObjectURL(blob);

            link.href = csvUrl;
            link.style = "visibility:hidden";
            link.download = filename;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    handleMonthChange(val) {
        this.setState({selectedMonth: val.value});
    }

    handleYearChange(val) {
        this.setState({selectedYear: val.value});
    }

    handleRoleChange(val) {
        this.setState({selectedRole: val.value});
    }

    formatCurrency(amount) {
        return (
            new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD', minimumFractionDigits: 2
            }).format(amount));
    }

    //toggle tabs
    toggle = (tab) => {
        if (this.state.activeItem !== tab) {
            this.setState({
                activeItem: tab
            });
        }
    };

    toggleSaveFiltersModal() {
        let res = !this.state.saveFiltersToggle;
        this.setState({
            saveFiltersToggle: res
        });
    }

    toggleListFiltersModal() {
        let res = !this.state.listFiltersToggle;
        this.setState({
            listFiltersToggle: res
        });
    }

    saveMyFilters() {
        const { currentUser } = this.context;
        let name = this.state.myFilterName,
            locs = this.state.locationsSelected,
            qf = this.state.quickFilterSelected,
            techs = this.state.techsSelected,
            reps = this.state.salesRepsSelected;

        let filters = {
            userId: currentUser.id,
            name: name,
            locationIds: locs.join(','),
            dateQuickFilter: qf.label,
            userIds: reps.toString() + "|" + techs.toString(),
        };
        userService.addUserReportFilters(filters).then(res => {
            const userprofile = this.context.usersIndexed[this.context.currentUser.id];
            let fil = [];

            if (userprofile.userReportFilters && userprofile.userReportFilters.length > 0) {
                userprofile.userReportFilters.forEach((val, idx) => {
                    fil.push({
                        label: val.name,
                        value: val
                    });
                });
            }
            this.setState({
                userReportFilters: fil
            });

            this.setState({
                saveFiltersToggle: false
            });
        }).catch(err => {
            console.log(err);
        });
    }

    deleteMyFilter(id) {
        userService.removeUserReportFilter(id).then(res => {
            const userprofile = this.context.usersIndexed[this.context.currentUser.id];
            let fil = [];

            if (userprofile.userReportFilters && userprofile.userReportFilters.length > 0) {
                userprofile.userReportFilters.forEach((val, idx) => {
                    fil.push({
                        label: val.name,
                        value: val
                    });
                });
            }
            this.setState({
                userReportFilters: fil
            });
        }).catch(err => {
            console.log(err);
        });
    }

    loadSelectedFilter(obj) {
        let opts = QuickFilter.getOptions();
        let allLocs = this.state.allInternalLocations;
        let locs = obj.locationIds && obj.locationIds.includes(",") ? obj.locationIds.split(',').map(x => parseInt(x)) : (obj.locationIds && !obj.locationIds.includes(",") ? [parseInt(obj.locationIds)] : []),
            users = obj.userIds && obj.userIds.length > 0 ? obj.userIds.split("|") : "",
            reps = users[0].split(',').map(x => parseInt(x)) || [],
            techs = users[1].split(',').map(x => parseInt(x)) || [],
            qf = obj.dateQuickFilter,
            selQf = opts.filter(x => x.label === qf)[0];
        let locNames = '';

        this.handleQuickFilter(selQf);
        allLocs.forEach((item) => {
            if (locs.includes(item.value)) {
                item.checked = true;
                locNames += locNames.length === 0 ? item.text : ', ' + item.text;
            }
            else {
                item.checked = false;
            }
        });
        if (locNames.length === 0) {
            locNames = "Choose Locations";
        }
        this.setState({
            allInternalLocations: allLocs,
            selectedLocationNames: locNames,
            selectedLocations: locs,
        });
        //this.setState({
        //    locationsSelected: locs,
        //})
        this.getLocationValue(locs);
        this.getSalesRepsValue(reps);
        this.handleTechChange(techs);
    }

    renderProductionMonthlyModal() {
        return (
            <MDBModal
            fullWidth
                centered
                size="lg"
                toggle={() => this.toggleProductionModal()}
                isOpen={this.state.productionMonthlyToggle}>
                <MDBModalHeader style={{backgroundColor: '#FFFFFF'}}>
                    Production Report
                </MDBModalHeader>
                <MDBModalBody>
                    {this.state.processing ? this.renderLoadingSpinner() :
                        <div>
                            <Row style={{margin: '1rem'}}>
                                <MDBCol md={"12"}>
                                    <Select
                                        placeholder={"Select Month"}
                                        style={{margin: '1rem'}}
                                        options={this.state.monthList}
                                        onChange={this.handleMonthChange.bind(this)}
                                        menuPortalTarget={ document.body }
                                        styles={ { menuPortal: base => ({ ...base, zIndex: 9999 }) } }
                                        />
                                </MDBCol>
                            </Row>
                            <Row style={{margin: '1rem'}}>
                                <MDBCol md={"12"}>
                                    <Select
                                        placeholder={"Select Year"}
                                        style={{margin: '1rem'}}
                                        options={this.state.yearList}
                                        onChange={this.handleYearChange.bind(this)}
                                        menuPortalTarget={ document.body }
                                        styles={ { menuPortal: base => ({ ...base, zIndex: 9999 }) } }
                                        >
                                    </Select>
                                </MDBCol>
                            </Row>
                            <Row style={{margin: '1rem'}}>
                                <MDBCol md={"12"}>
                                    <Select
                                        placeholder={"Select Role"}
                                        style={{margin: '1rem'}}
                                        options={this.state.roleList}
                                        onChange={this.handleRoleChange.bind(this)}
                                        menuPortalTarget={ document.body }
                                        styles={ { menuPortal: base => ({ ...base, zIndex: 9999 }) } }
                                        >
                                    </Select>
                                </MDBCol>
                            </Row>
                        </div>
                    }
                </MDBModalBody>
                <MDBModalFooter>
                    <Button color={'success'}
                        floating
                        size={'sm'}
                        onClick={this.getProductionReport}
                        disabled={this.state.processing}
                        data-tip={"Run Report"}>
                        <MDBIcon icon="check" style={{fontSize: "2em"}} />
                    </Button>
                    <Button color={'red'}
                        floating
                        size={'sm'}
                        data-tip={"Cancel"}
                        onClick={this.toggleProductionModal}>
                        <MDBIcon icon="times" style={{fontSize: "2em"}} />
                    </Button>
                    <ReactTooltip />
                </MDBModalFooter>
            </MDBModal>
        );
    }

    renderSaveFiltersModal() {
        let locs = this.state.locationsSelected,
            allLocs = this.state.allInternalLocations,
            qf = this.state.quickFilterSelected,
            cannotSave = true;
        let colRes = [];
        var resLocs = allLocs.filter(x => {
            return locs && locs.length > 0 ? locs.includes(x.value) : [];
        });

        if (resLocs.length === 1) {
            colRes.push(resLocs[0]);
        }
        else if (resLocs.length > 1) {
            let rowsCt = 0, ctr = 1;
            if (resLocs.length % 2 === 1) {
                rowsCt = (resLocs.length + 1) / 2;
            }
            else {
                rowsCt = resLocs.length / 2;
            }
            for (var i = 0; i < resLocs.length; i++) {
                colRes.push(resLocs[i]);
                if (ctr === resLocs.length) {
                    break;
                }
                ctr++;
                colRes.push(resLocs[rowsCt + i]);
                if (ctr === resLocs.length) {
                    break;
                }
                ctr++;
            }
        }

        cannotSave = qf === null || (!colRes || colRes.length === 0);

        return (
            <MDBModal
                fullWidth
                centered
                size="xl"
                toggle={() => this.toggleSaveFiltersModal()}
                isOpen={this.state.saveFiltersToggle}>
                <MDBModalHeader style={{backgroundColor: '#FFFFFF'}}>
                    Save My Filters
                </MDBModalHeader>
                <MDBModalBody>
                    <MDBRow>
                        <MDBCol size="12">
                            <label><b>Date Range:</b></label>
                            {qf ? <label style={{marginLeft: '4px'}}>{qf.label}</label> : <label style={{color: 'red', marginLeft: '4px'}}>No Dates Selected</label>}
                        </MDBCol>
                        <MDBCol size="12">
                            <hr style={{marginBottom: '4px', marginTop: '4px'}} />
                        </MDBCol>
                    </MDBRow>
                    <MDBRow>
                        <MDBCol size="12">
                            <b>Locations:</b>
                        </MDBCol>
                    </MDBRow>
                    <MDBRow style={{maxHeight: '200px', overflowY: 'scroll'}}>
                        {/* {resLocs && resLocs.length > 0 ? resLocs.map(x => {
                                return <MDBCol size='6'>{x.text}</MDBCol>
                            }) : <MDBCol size="12"><label style={{color: 'red'}}>No Locations Selected</label></MDBCol>} */}
                        {colRes && colRes.length > 0 ? colRes.map(x => {
                            return <MDBCol key={x.value} size='6'>{x.text}</MDBCol>;
                        }) : <MDBCol size="12"><label style={{color: 'red'}}>No Locations Selected</label></MDBCol>}
                    </MDBRow>
                    <MDBRow>
                        <MDBCol size="12">
                            <hr style={{marginBottom: '4px', marginTop: '4px'}} />
                        </MDBCol>
                        <MDBCol size="12">
                            <label><b>Filter Name:</b></label>
                            <MDBInput
                                containerClass={"noMargin"}
                                outline
                                value={this.state.myFilterName}
                                onChange={(e) => {
                                    this.setState({myFilterName: e.target.value});
                                }} />
                        </MDBCol>
                    </MDBRow>
                </MDBModalBody>
                <MDBModalFooter>
                    <Button color={'success'}
                        floating
                        size={'sm'}
                        disabled={cannotSave}
                        onClick={() => {this.saveMyFilters();}}
                        data-tip={"Save Filters"}>
                        <MDBIcon icon="check" style={{fontSize: "2em"}} />
                    </Button>
                    <Button color={'red'}
                        floating
                        size={'sm'}
                        data-tip={"Cancel"}
                        onClick={() => {this.toggleSaveFiltersModal();}}>
                        <MDBIcon icon="times" style={{fontSize: "2em"}} />
                    </Button>
                    <ReactTooltip />
                </MDBModalFooter>
            </MDBModal>
        );
    }

    toggleProductionModal = () => {
        let res = !this.state.productionMonthlyToggle;
        if (!res) {
            this.setState({
                selectedMonth: null,
                selectedYear: null,
                selectedRole: null,
            });
        }
        this.setState({
            productionMonthlyToggle: res
        });
    };

    renderLoadingSpinner() {
        return (
            <Container className="mt-5">
                <div style={{textAlign: 'center', verticalAlign: 'center'}}>
                    <Spinner multicolor />
                </div>
            </Container>
        );
    }

    renderViewToolbar() {
        //const { currentUser, setContextItem, allUsers } = this.context;
        const {currentUser} = this.context;

        let ap = this.state.allProducts,
            bgColor = ap ? 'white' : 'orange',
            text = ap ? 'All Products' : 'Points-Only Products';

        let cannotUseMyFilters = (!this.state.allInternalLocations || this.state.allInternalLocations.length === 0) &&
            (!this.state.allSalesReps || this.state.allSalesReps.length === 0) &&
            (!this.state.allTechs || this.state.allTechs.length === 0);

        return (
            <MDBCardHeader
                style={{
                    paddingTop: 8,
                    paddingBottom: 8,
                    marginBottom: 10,
                    fontSize: 18,
                    backgroundColor: '#5881C1'
                }}>
                <MDBRow style={ { padding: '.5%' } }>
                    <MDBCol size={'8'}>
                        <MDBRow gap={1}>
                            <MDBCol size={'5.9'}>
                                {this.renderLocationSelect()}
                            </MDBCol>

                            <MDBCol size={'5.9'} style={{marginBottom: '10px'}}>
                                {this.renderRepTechSelect()}
                                {/*<UserDropdown*/}
                                {/*    autoSelect={true}*/}
                                {/*    setContextItem={setContextItem.bind(this)}*/}
                                {/*    allUsers={allUsers}*/}
                                {/*    selectAll={true}*/}
                                {/*    showActiveOnly={true}*/}
                                {/*    label="Choose Techs"*/}
                                {/*    roleFilters={["TECHNICIAN"]}*/}
                                {/*    locationFilters={this.state.locationsSelected}*/}
                                {/*    multiple={true}*/}
                                {/*    className={(this.state.activeItem === "7" ? "searchfield" : "searchfield hidden")}*/}
                                {/*    selectedIds={this.state.techsSelected || []}*/}
                                {/*    selected={this.handleTechChange.bind(this)}*/}
                                {/*    canClear={this.state.canClear}*/}
                                {/*    resetFlag={() => {*/}
                                {/*        this.setState({ canClear: false });*/}
                                {/*    }}*/}
                                {/*/>*/}
                                {/*<UserDropdown*/}
                                {/*    autoSelect={true}*/}
                                {/*    setContextItem={setContextItem.bind(this)}*/}
                                {/*    allUsers={allUsers}*/}
                                {/*    selectAll={true}*/}
                                {/*    showActiveOnly={true}*/}
                                {/*    label="Choose Sales Reps"*/}
                                {/*    roleFilters={["ADMIN", "SALES", "SALES_MANAGER"]}*/}
                                {/*    locationFilters={this.state.locationsSelected}*/}
                                {/*    multiple={true}*/}
                                {/*    className={(["6", "7", "8"].includes(this.state.activeItem) ? "searchfield hidden" : "searchfield")}*/}
                                {/*    selectedIds={this.state.salesRepsSelected || []}*/}
                                {/*    selected={this.getSalesRepsValue.bind(this)}*/}
                                {/*    canClear={this.state.canClear}*/}
                                {/*    resetFlag={() => {*/}
                                {/*        this.setState({ canClear: false });*/}
                                {/*    }}*/}
                                {/*/>*/}
                            </MDBCol>

                            <MDBCol size={'12'}>
                                {this.renderDateRow()}
                            </MDBCol>
                        </MDBRow>
                    </MDBCol>

                    <MDBCol size={'4'}>
                        <div style={{ marginTop: '-1%', marginBottom: "3%" }}>

                            <Button className="px-2 toolbarButton"
                                outline
                                rounded
                                size="sm"
                                color={bgColor}
                                data-place={'bottom'}
                                data-tip={text}
                                onClick={() => {
                                    this.setState({
                                        allProducts: !ap,
                                        pointsOnlyProducts: ap
                                    });
                                }}
                                style={{ marginRight: '16px'}}
                                >
                                <MUIInventoryIcon data-place={'bottom'} style={{ color: bgColor, height: 20, width: 20 }} />
                            </Button>
                            <Button className="px-2 toolbarButton"
                                outline
                                rounded
                                size="sm"
                                color={'success'}
                                data-place={'bottom'}
                                data-tip={"Generate Reports"}
                                onClick={() => {
                                    let gc = this.state.generateClicked;
                                    this.setState({
                                        generateClicked: gc + 1
                                    });
                                }}
                                style={{ marginRight: '16px'}}
                                >
                                <MDBIcon icon="chart-line" style={{fontSize: "2em"}} />
                            </Button>

                            <Button className="px-2 toolbarButton"
                                outline
                                rounded
                                size="sm"
                                color={"secondary"}
                                data-place={'bottom'}
                                data-tip={"Download Dashboard CSV"}
                                onClick={() => {
                                    this.getDashboardInformation();
                                }}
                                style={{ marginRight: '16px'}}
                                >
                                <MDBIcon icon="download" style={{fontSize: "2em"}} />
                            </Button>

                            {['ADMIN', 'EXECUTIVE_MANAGEMENT', 'BUSINESS_SUPPORT'].includes(currentUser.role) ||
                                (currentUser.role && currentUser.role.indexOf("MANAGER") > 0) ?
                                <Button className="px-2 toolbarButton"
                                    outline
                                    rounded
                                    size="sm"
                                    color={"orange"}
                                    data-place={'bottom'}
                                    data-tip={"View Production Monthly Report"}
                                    onClick={() => {
                                        this.toggleProductionModal();
                                    }}
                                    style={{ marginRight: '16px'}}
                                    >
                                    <MDBIcon icon="calendar-alt" style={{fontSize: "2em"}} />
                                </Button>
                                : ''}

                            <Button className="px-2 toolbarButton"
                                outline
                                rounded
                                size="sm"
                                color={"elegant"}
                                data-place={'bottom'}
                                data-tip={"Save My Filters"}
                                onClick={() => {this.toggleSaveFiltersModal();}}
                                style={{ marginRight: '16px'}}
                                >
                                <MDBIcon icon="save" style={{fontSize: "2em"}} />
                            </Button>

                            <Button className="px-2 toolbarButton"
                                outline
                                rounded
                                size="sm"
                                color={"secondary"}
                                data-place={'bottom'}
                                data-tip={"View My Filters"}
                                onClick={() => {this.toggleListFiltersModal();}}
                                style={{ marginRight: '16px'}}
                                >
                                <MDBIcon icon="list" style={{fontSize: "2em"}} />
                            </Button>
                        </div>
                        <Select
                            options={this.state.userReportFilters}
                            placeholder='My Filters'
                            disabled={cannotUseMyFilters}
                            onChange={(e) => {this.loadSelectedFilter(e.value);}}
                        />

                    </MDBCol>
                </MDBRow>
            </MDBCardHeader>
        );
    }

    renderListFiltersModal() {
        const {currentUser} = this.context;
        return (
            <MDBModal
                fullWidth
                centered
                size="lg"
                toggle={() => this.toggleListFiltersModal()}
                isOpen={this.state.listFiltersToggle}>
                <MDBModalHeader style={{backgroundColor: '#FFFFFF'}}>
                    My Filters
                </MDBModalHeader>
                <MDBModalBody>
                    <div style={{maxHeight: '200px', overflowY: 'scroll', overflowX: 'hidden'}}>
                        {
                            currentUser.userReportFilters && currentUser.userReportFilters.length > 0 ?
                                currentUser.userReportFilters.map(x => {
                                    return (
                                        <MDBRow key={x.name}>
                                            <MDBCol size={'2'}>
                                                <Button color={'red'}
                                                    floating
                                                    size={'sm'}
                                                    data-tip={"Delete"}
                                                    onClick={() => {this.deleteMyFilter(x.id);}}>
                                                    <MDBIcon icon="times" style={{fontSize: "2em"}} />
                                                </Button>
                                            </MDBCol>
                                            <MDBCol size={'10'}>
                                                <label style={{marginTop: '16px'}}>{x.name}</label>
                                            </MDBCol>
                                        </MDBRow>
                                    );
                                })
                                : <MDBRow><MDBCol size={'12'} style={{color: 'red'}}>No saved filters</MDBCol></MDBRow>
                        }
                    </div>
                </MDBModalBody>
                <MDBModalFooter>
                    <Button color={'red'}
                        floating
                        size={'sm'}
                        data-tip={"Close"}
                        onClick={() => {this.toggleListFiltersModal();}}>
                        <MDBIcon icon="times" style={{fontSize: "2em"}} />
                    </Button>
                    <ReactTooltip />
                </MDBModalFooter>
            </MDBModal>
        );
    }

    //load the data in the table
    renderContent() {
        let filters = {};
        let st = this.state;

        let topFilters = {
            quickFilter: st.quickFilter,
            showDatePicker: st.showDatePicker,
            salesRepsSelected: st.salesRepsSelected || [],
            startDate: st.startDate,
            endDate: st.endDate,
            pointsOnlyProducts: st.pointsOnlyProducts,
            techsSelected: st.techsSelected || [],
            locationsSelected: st.locationsSelected
        };

        if (Setting.get("orders.settings")) {
            filters = Setting.get("orders.settings");
        }

        if (this.state.processing) {
            return (this.renderLoadingSpinner);
        }

        return (
            <div>
                {this.renderViewToolbar()}
                <div style={{padding: '2rem'}} className="classic-tabs">
                    <ToastContainer
                        hideProgressBar={false}
                        newestOnTop={true}
                        autoClose={5000}
                        style={{marginTop: "75px"}}
                    />
                    {this.renderProductionMonthlyModal()}
                    {this.renderSaveFiltersModal()}
                    {this.renderListFiltersModal()}

                    <Row>
                        <Col md="12">
                            <MDBNav classicTabs className="nav-justified" style={{backgroundColor: "#5881C1"}}>
                                <MDBNavItem>
                                    <MDBNavLink link to="#" active={this.state.activeItem === "1"}
                                        onClick={() => {
                                            this.toggle("1");
                                        }}
                                        role="tab"
                                    >
                                        <MDBIcon icon="chart-line" size="2x" /><br /> Sales Report
                                    </MDBNavLink>
                                </MDBNavItem>

                                <MDBNavItem>
                                    <MDBNavLink link to="#" active={this.state.activeItem === "2"}
                                        onClick={() => {
                                            this.toggle("2");
                                        }}
                                        role="tab"
                                    >
                                        <MDBIcon icon="tasks" size="2x" /><br /> Activity Report
                                    </MDBNavLink>
                                </MDBNavItem>

                                <MDBNavItem>
                                    <MDBNavLink link to="#" active={this.state.activeItem === "3"}
                                        onClick={() => {
                                            this.toggle("3");
                                        }}
                                        role="tab"
                                    >
                                        <MDBIcon icon="check" size="2x" /><br /> Approval Report
                                    </MDBNavLink>
                                </MDBNavItem>

                                <MDBNavItem>
                                    <MDBNavLink link to="#" active={this.state.activeItem === "4"}
                                        onClick={() => {
                                            this.toggle("4");
                                        }}
                                        role="tab"
                                    >
                                        <MDBIcon icon="money-bill" size="2x" /><br /> Expense Report
                                    </MDBNavLink>
                                </MDBNavItem>

                                <MDBNavItem>
                                    <MDBNavLink link to="#" active={this.state.activeItem === "5"}
                                        onClick={() => {
                                            this.toggle("5");
                                        }}
                                        role="tab"
                                    >
                                        <MDBIcon icon="users" size="2x" /><br /> Account Report
                                    </MDBNavLink>
                                </MDBNavItem>

                                <MDBNavItem>
                                    <MDBNavLink link to="#" active={this.state.activeItem === "6"}
                                        onClick={() => {
                                            this.toggle("6");
                                        }}
                                        role="tab"
                                    >
                                        <MDBIcon icon="cogs" size="2x" /><br /> Services Report
                                    </MDBNavLink>
                                </MDBNavItem>

                                <MDBNavItem>
                                    <MDBNavLink link to="#" active={this.state.activeItem === "7"}
                                        onClick={() => {
                                            this.toggle("7");
                                        }}
                                        role="tab"
                                    >
                                        <MDBIcon icon="truck" size="2x" /><br /> Delivery Report
                                    </MDBNavLink>
                                </MDBNavItem>

                                <MDBNavItem>
                                    <MDBNavLink link to="#" active={this.state.activeItem === "8"}
                                        onClick={() => {
                                            this.toggle("8");
                                        }}
                                        role="tab"
                                    >
                                        <MDBIcon icon="comment" size="2x" /><br /> Complaint Report
                                    </MDBNavLink>
                                </MDBNavItem>

                                <MDBNavItem>
                                    <MDBNavLink link to="#" active={this.state.activeItem === "9"}
                                        onClick={() => {
                                            this.toggle("9");
                                        }}
                                        role="tab"
                                    >
                                        <MDBIcon icon="comment" size="2x" /><br /> Service Order Reason Report
                                    </MDBNavLink>
                                </MDBNavItem>
                            </MDBNav>

                            <TabContent className="card" activeItem={this.state.activeItem}>
                                <MUIBox role="tabpanel" sx={{ display: st.activeItem === "1" ? "block" : "none" }}>
                                    <SalesReport csvFunction={this.clientCSV.bind(this)} topFilters={topFilters}
                                        filters={filters} generateClicked={this.state.generateClicked} />
                                </MUIBox>
                                <MUIBox role="tabpanel" sx={{ display: st.activeItem === "2" ? "block" : "none" }}>
                                    <ActivitiesReport csvFunction={this.clientCSV.bind(this)} topFilters={topFilters}
                                        filters={filters} generateClicked={this.state.generateClicked} />
                                </MUIBox>
                                <MUIBox role="tabpanel" sx={{ display: st.activeItem === "3" ? "block" : "none" }}>
                                    <ApprovalReport csvFunction={this.clientCSV.bind(this)} topFilters={topFilters}
                                        filters={filters} generateClicked={this.state.generateClicked} />
                                </MUIBox>
                                <MUIBox role="tabpanel" sx={{ display: st.activeItem === "4" ? "block" : "none" }}>
                                    <ExpensesReport csvFunction={this.clientCSV.bind(this)} topFilters={topFilters}
                                        filters={filters} generateClicked={this.state.generateClicked} />
                                </MUIBox>
                                <MUIBox role="tabpanel" sx={{ display: st.activeItem === "5" ? "block" : "none" }}>
                                    <AccountReport csvFunction={this.clientCSV.bind(this)} topFilters={topFilters}
                                        filters={filters} generateClicked={this.state.generateClicked} />
                                </MUIBox>
                                <MUIBox role="tabpanel" sx={{ display: st.activeItem === "6" ? "block" : "none" }}>
                                    <ServicesReport csvFunction={this.clientCSV.bind(this)} topFilters={topFilters}
                                        filters={filters} generateClicked={this.state.generateClicked} />
                                </MUIBox>
                                <MUIBox role="tabpanel" sx={{ display: st.activeItem === "7" ? "block" : "none" }}>
                                    <DeliveryReport csvFunction={this.clientCSV.bind(this)} topFilters={topFilters}
                                        filters={filters} generateClicked={this.state.generateClicked} />
                                </MUIBox>
                                <MUIBox role="tabpanel" sx={{ display: st.activeItem === "8" ? "block" : "none" }}>
                                    <ComplaintReport csvFunction={this.clientCSV.bind(this)} topFilters={topFilters}
                                        filters={filters} generateClicked={this.state.generateClicked} />
                                </MUIBox>
                                <MUIBox role="tabpanel" sx={{ display: st.activeItem === "9" ? "block" : "none" }}>
                                    <ServiceOrderReasonReport csvFunction={this.clientCSV.bind(this)} topFilters={topFilters}
                                        filters={filters} generateClicked={this.state.generateClicked} />
                                </MUIBox>
                            </TabContent>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}
